import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53cb1b1c"
import script from "./projectTowerDetails.js?vue&type=script&lang=js&external"
export * from "./projectTowerDetails.js?vue&type=script&lang=js&external"
import style0 from "./projectTowerDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports